export const CREATE_PAYMENT_LINK_SUCCESS = 'CREATE_PAYMENT_LINK_SUCCESS';
export const CREATE_PAYMENT_LINK = 'CREATE_PAYMENT_LINK';

export type orderPaymentDetails = {
  id: string;
  orderId: string;
  paymentId: string;
  bank_transaction_id: string;
  amount: number | string;
  amount_refunded: number | string;
  amount_transferred: null | string;
  bank: string;
  base_amount: null | string;
  captured: boolean;
  card: null | string;
  card_id: null | string;
  contact: string;
  created_at: string;
  currency: string;
  description: string;
  email: string;
  entity: string;
  error_code: null | string;
  error_description: null | string;
  error_reason: null | string;
  error_source: null | string;
  error_step: null | string;
  fee: number | string;
  fee_bearer: null | string;
  international: boolean;
  invoice_id: null | string;
  method: string;
  order_id: string;
  refund_status: null | string;
  status: string;
  tax: number | string;
  vpa: null | string;
  wallet: null | string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
};
type Transfers = {
  id: string;
  paymentLinkId: string;
  account: string;
  accountNumber: string;
  bankIfsc: string;
  accountName: string;
  amountType: string;
  amount: number | string;
  currency: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
};

export type CreatePaymentLinkResponse = {
  id: string;
  applicationId: string;
  applicationNumber: string;
  accept_partial: boolean;
  amount: number | string;
  amount_paid: number | string;
  cancelled_at: string;
  created_at: string;
  currency: string;
  customer_name: string;
  customer_contact: string;
  customer_email: string;
  description: string;
  expire_by: string;
  expired_at: string;
  first_min_partial_amount: number;
  paymentLink_id: string;
  notify_sms: boolean;
  notify_email: boolean;
  order_id: null | string;
  reference_id: string;
  reminder_enable: boolean;
  reminder_status: null | string;
  short_url: string;
  status: string;
  updated_at: string;
  method: string;
  bank_account_number: string;
  bank_account_name: string;
  bank_account_ifsc: string;
  paymentLinkStatusUpdated: boolean;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  order: {
    id: string;
    paymentLinkId: string;
    order_id: string;
    amount: number | string;
    amount_paid: number | string;
    amount_due: number | string;
    attempts: string;
    created_at: string;
    currency: string;
    entity: string;
    offer_id: null | string;
    receipt: string;
    status: string;
    createdBy: string;
    updatedBy: string;
    createdAt: string;
    updatedAt: string;
    paymentdetails: orderPaymentDetails[];
  };
  transfers: Transfers[];
};

export type CancelPaymentResponse = {
  accept_partial: boolean;
  amount: number | string;
  amount_paid: number | string;
  callback_method: string;
  callback_url: string;
  cancelled_at: number | string;
  created_at: number | string;
  currency: string;
  customer: {
    contact: string;
    email: string;
    name: string;
  };
  description: string;
  expire_by: number | string;
  expired_at: number | string;
  first_min_partial_amount: number | string;
  id: string;
  notes: null | string;
  notify: {
    email: boolean;
    sms: boolean;
  };
  order_id: string;
  payments: [];
  reference_id: string;
  reminder_enable: boolean;
  reminders: {
    status: string;
  };
  short_url: string;
  status: string;
  updated_at: number | string;
  upi_link: boolean;
  user_id: string;
};
